import React from 'react';
import { Grid, Box, Typography, Stack } from '@mui/material';
import { PillButton } from '../../../components/superAdminUi';
import FormSectionHeader from '../../../components/common/FormSectionHeader';

const Fact = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>{value || '—'}</Typography>
  </Stack>
);

// Step 2 of the group-edit wizard: read-only recap. Save lives in the wizard footer; on
// success this swaps to a confirmation panel.
export default function ReviewStep({ values, saved, onGoToGroup }) {
  if (saved) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Group updated</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {values.name} has been saved.
        </Typography>
        <PillButton type="button" $variant="danger" $size="lg" onClick={onGoToGroup}>Back to group</PillButton>
      </Box>
    );
  }

  const customerTypes = values.customerType
    ? (() => { try { return JSON.parse(values.customerType); } catch (e) { return []; } })()
    : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormSectionHeader title="Review & save" first />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Group</Typography>
        <Fact label="Name" value={values.name} />
        <Fact label="Display name" value={values.groupName} />
        <Fact label="Type" value={values.groupType} />
        <Fact label="GUID" value={values.matGroupUID} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Classification</Typography>
        <Fact label="Country" value={values.country} />
        <Fact label="Storage" value={values.dataStorageLocation} />
        <Fact label="Customer types" value={customerTypes.join(', ')} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Settings</Typography>
        <Fact label="MAT Heat Map" value={values.isDisplayMatHeatMap ? 'On' : 'Off'} />
        <Fact label="Anonymized" value={values.isAnnonymised ? 'On' : 'Off'} />
        <Fact label="Test account" value={values.isTestAccount ? 'On' : 'Off'} />
      </Grid>
    </Grid>
  );
}
